import { initialize } from "launchdarkly-js-client-sdk"
import { useEffect, useState } from "react"

const anonymousUserContext = {
    kind: "user",
    key: "anonymous",
    anonymous: true,
    platform: "web",
}

const featureFlagsClient = initialize(window.ld_client_id, anonymousUserContext, {
    sendEventsOnlyForVariation: true,
})
Object.freeze(featureFlagsClient)

let ready = false
featureFlagsClient.on("ready", () => {
    ready = true
    if (process.env.NODE_ENV !== "production" && featureFlagsUsedBeforeInit.size > 0) {
        const flags = Array.from(featureFlagsUsedBeforeInit)
        flags.sort()
        console.error(
            "[LaunchDarkly] Feature flags were used before the client initialized.\n" +
                "  When this happens, the default value (e.g. `false`) is" +
                " returned instead of the flag status in LD.\n" +
                flags.map(flag => `  - ${flag}`).join("\n")
        )
    }
})

export const featureFlagsUsedBeforeInit = new Set<string>()
export const featureFlagsClientIsReady = (): boolean => ready

export const useFeatureFlagsClientIsReady = (): boolean => {
    const [isReady, setIsReady] = useState(false)
    useEffect(() => {
        if (featureFlagsClientIsReady()) {
            setIsReady(true)
            return
        }
        // The "ready" event will always be emitted by the client, whether it successfully initialized or not.
        // If the client did not initialize successfully, it will serve default feature flag values.
        featureFlagsClient.on("ready", () => {
            setIsReady(true)
        })
    }, [])
    return isReady
}

export default featureFlagsClient
